<template>
  <div class="u-popup-wrap">
    <div class="container">
      <form class="popup add-property-popup" @submit.prevent="handleSubmit">
        <div class="popup-head">
          <div class="left">
            <div class="close" @click="closePopup">
              <img src="@/assets/blue-x.svg" alt="x" />
            </div>
            <p class="popup-title">Add New Property</p>
          </div>
          <button
            :class="['save-btn', { active: isActiveBtn }]"
            @click="handleSubmit"
            :disabled="!isActiveBtn"
          >
            <span>Save</span>
            <img src="@/assets/cloud.svg" alt="cloud" />
          </button>
        </div>
        <div class="popup-body">
          <div class="inp-wrap">
            <p class="inp-title">
              Property name:
              <sup>*</sup>
            </p>
            <input
              type="text"
              class="inp"
              name="name"
              v-model="propertyName"
              placeholder="Type here..."
            />
          </div>
          <div class="inp-group">
            <div class="inp-wrap">
              <p class="inp-title">
                Street 1
                <sup>*</sup>
              </p>
              <input
                type="text"
                class="inp"
                name="street1"
                v-model="street1"
                placeholder="Type here..."
              />
            </div>
            <div class="inp-wrap">
              <p class="inp-title">
                Street 2
                <sup>*</sup>
              </p>
              <input
                type="text"
                class="inp"
                name="street2"
                v-model="street2"
                placeholder="Type here..."
              />
            </div>
          </div>
          <div class="inp-group">
            <div class="inp-wrap">
              <p class="inp-title">
                City
                <sup>*</sup>
              </p>
              <input
                type="text"
                class="inp"
                name="city"
                v-model="city"
                placeholder="Type here..."
              />
            </div>
            <div class="inp-wrap">
              <p class="inp-title">
                State/Region
                <sup>*</sup>
              </p>
              <multiselect
                v-if="selectedCountry === 'United States'"
                v-model="selectedState"
                :options="usStates"
                :select-label="'Select'"
                :deselect-label="'Remove'"
                placeholder="Select a state"
                class="inp"
              />
              <input
                v-else
                type="text"
                class="inp"
                name="state"
                v-model="state"
                placeholder="Type here..."
              />
            </div>
          </div>
          <div class="inp-group">
            <div class="inp-wrap">
              <p class="inp-title">
                Postal Code
                <sup>*</sup>
              </p>
              <input
                type="text"
                class="inp"
                name="postalCode"
                v-model="postalCode"
                placeholder="Type here..."
              />
            </div>
            <div class="inp-wrap">
              <p class="inp-title">
                Country
                <sup>*</sup>
              </p>
              <multiselect
                v-model="selectedCountry"
                :options="countries"
                :select-label="'Select'"
                :deselect-label="'Remove'"
                placeholder="Select a country"
                class="inp"
              />
            </div>
          </div>
          <button
            :class="['bottom-save-btn', { active: isActiveBtn }]"
            @click="handleSubmit"
            :disabled="!isActiveBtn"
          >
            <span>Save</span>
            <img src="@/assets/cloud.svg" alt="cloud" />
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect
  },
  props: {
    selectLabel: {
      type: String,
      default: "Press"
    }
  },
  data: function() {
    return {
      countries: [
        "Afghanistan",
        "Aland Islands",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia, Plurinational State of",
        "Bonaire, Sint Eustatius and Saba",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "British Indian Ocean Territory",
        "Brunei Darussalam",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cape Verde",
        "Cayman Islands",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands",
        "Colombia",
        "Comoros",
        "Congo",
        "Congo, The Democratic Republic of the",
        "Cook Islands",
        "Costa Rica",
        "Cote d'Ivoire",
        "Croatia",
        "Cuba",
        "Curacao",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Ethiopia",
        "Falkland Islands (Malvinas)",
        "Faroe Islands",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "French Southern Territories",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Heard Island and McDonald Islands",
        "Holy See (Vatican City State)",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran, Islamic Republic of",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Korea, Democratic People's Republic of",
        "Korea, Republic of",
        "Kosovo",
        "Kuwait",
        "Kyrgyzstan",
        "Lao People's Democratic Republic",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macao",
        "Macedonia, The Former Yugoslav Republic of",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia, Federated States of",
        "Moldova, Republic of",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Northern Cyprus",
        "Northern Mariana Islands",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestine, State of",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Pitcairn Islands",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Reunion",
        "Romania",
        "Russian Federation",
        "Rwanda",
        "Western Sahara",
        "Saint Barthelemy",
        "Saint Helena, Ascension and Tristan da Cunha",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Martin (French Part)",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Sint Maarten (Dutch Part)",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "Somaliland",
        "South Africa",
        "South Georgia and the South Sandwich Islands",
        "South Ossetia",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Svalbard and Jan Mayen",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syrian Arab Republic",
        "Taiwan, Province of China",
        "Tajikistan",
        "Tanzania, United Republic of",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tokelau",
        "Tonga",
        "Transnistria",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks and Caicos Islands",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States",
        "United States Minor Outlying Islands",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela, Bolivarian Republic of",
        "Vietnam",
        "Virgin Islands, British",
        "Virgin Islands, US",
        "Wallis and Futuna",
        "Yemen",
        "Zambia",
        "Zimbabwe"
      ],

      usStates: [
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District of Columbia",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming"
      ],

      selectedCountry: "United States",

      selectedState: "",
      propertyName: "",
      street1: "",
      street2: "",
      city: "",
      state: "",
      postalCode: ""
    };
  },
  computed: {
    isActiveBtn() {
      return (
        this.propertyName.length > 0 &&
        this.street1.length > 0 &&
        this.city.length > 0 &&
        this.postalCode.length > 0 &&
        this.selectedCountry.length > 0 &&
        (this.selectedCountry !== "United States" ||
          this.selectedState.length > 0)
      );
    }
  },
  methods: {
    closePopup() {
      this.$store.commit("popups/hide", "addProperty");
    },
    async handleSubmit(e) {
      if (!this.isActiveBtn) {
        return;
      }

      let data = {
        country: this.selectedCountry,
        state: this.selectedState
      };

      [...e.currentTarget.elements].forEach(item => {
        if (item.name) data[item.name] = item.value;
      });

      this.$store.dispatch("properties/addProperty", data);

      this.$store.commit("popups/hide", "addProperty");
    }
  }
};
</script>

<style lang="sass">
@import ../helpers/mixins
@import "~vue-multiselect/dist/vue-multiselect.min.css"

form.add-property-popup
    background: #fff
    min-width: 640px
    +mobile(650px)
        margin-top: 700px
        min-width: 100%

    div.popup-head
        padding: 15px
        display: flex
        justify-content: space-between
        align-items: center
        box-shadow: inset 0px -1px 0px rgba(18, 76, 123, 0.24)

    div.close
        width: 44px
        height: 44px
        display: flex
        justify-content: center
        align-items: center
        padding: 5px
        background: linear-gradient(to bottom, rgba(191, 30, 46, 1) 0%, rgba(77, 16, 19, 1) 100%)
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.16)
        cursor: pointer

    div.left
        display: flex
        align-items: center

        p.popup-title
            font-size: 24px
            letter-spacing: 0.02em
            color: #505050
            font-weight: 700
            line-height: 28px
            margin: 0 0 0 15px

    button.save-btn
        display: flex
        justify-content: center
        align-items: center
        color: #fff
        outline: none
        border: none
        font-size: 18px
        font-weight: 500
        text-transform: uppercase
        padding: 10px 12px
        background: #CCCCCC
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.16)
        &.active
            background: #0d4779
            cursor: pointer
        img
            margin-left: 10px

    div.popup-body
        padding: 25px 50px
        +mobile(600px)
            padding: 20px

    div.inp-group
        display: flex
        justify-content: space-between
        +mobile(600px)
            flex-direction: column

        div.inp-wrap
            width: 50%
            padding: 0 5px
            +mobile(600px)
                padding: 0
                width: 100%

    div.inp-wrap
        margin-bottom: 25px

        p.inp-title
            font-size: 14px
            line-height: 146%
            color: #434F5B
            margin: 0
            margin-bottom: 5px
            sup
                color: #EB5757
                font-size: 20px
                font-weight: 500

        input.inp
            width: 100%
            padding: 12px
            font-size: 18px
            border: 1px solid #7ED3D4
            border-radius: 5px
            outline: none

    button.bottom-save-btn
        width: 100%
        background: #CCCCCC
        color: #fff
        padding: 10px
        outline: none
        display: flex
        justify-content: center
        align-items: center
        margin-top: 20px
        border: none
        font-size: 18px
        font-weight: 500
        padding: 16px
        text-transform: uppercase
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.16)
        img
            margin-left: 15px

    .bottom-save-btn.active
        background-color: #0d4779
        cursor: pointer

    .multiselect,
    .multiselect__input,
    .multiselect__single
      font-family: "Poppins", sans-serif
      font-size: 18px
      touch-action: manipulation


    .multiselect
      color: #000829///////////////

    .multiselect__tags
      min-height: 46px////
      display: block
      padding: 11px 40px 0 8px///
      font-size: 18px//////////
      border: 1px solid #7ED3D4////
      border-radius: 5px///////
      background: #fff


    .multiselect__select
      line-height: 16px
      display: block
      position: absolute
      box-sizing: border-box
      width: 40px
      height: 47px///////////
      right: 1px
      top: 1px
      padding: 4px 8px
      margin: 0
      text-decoration: none
      text-align: center
      cursor: pointer
      transition: transform 0.2s ease

    .multiselect__placeholder
      color: #757579////////////
      display: inline-block
      margin-bottom: 10px
      padding-top: 2px

    .multiselect__option--highlight
      background: #EBECEC////
      outline: none
      color: #35495E////


    .multiselect__option--highlight:after
      content: attr(data-select)
      background: #EBECEC////
      color: #35495E//////


    .multiselect__option--selected
      background: #EBECEC///
      color: #35495E
      font-weight: bold


    .multiselect__option--selected.multiselect__option--highlight
      background: #EBECEC////
      color: #000829///////////


    .multiselect__option--selected.multiselect__option--highlight:after
      background: #EBECEC///////
      content: attr(data-deselect)
      color: #000829////


    .multiselect--disabled .multiselect__current,
    .multiselect--disabled .multiselect__select
      background: #ededed
      color: #000829////


    .multiselect__option--disabled
      background: #ededed
      color: #000829///
      cursor: text
      pointer-events: none
</style>
